import { render, staticRenderFns } from "./nests.vue?vue&type=template&id=2bda71e0&"
import script from "./nests.vue?vue&type=script&lang=js&"
export * from "./nests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "nests.vue"
export default component.exports